// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as LearnMoreModal from "./LearnMoreModal.bs.js";
import * as ScoreDetailsModal from "./ScoreDetailsModal.bs.js";

function isModalOpen(modal_state) {
  return modal_state !== undefined;
}

function getModalComponent(modal_state, toggle_modal, isModalOpen, variant) {
  if (modal_state !== undefined) {
    if (modal_state.TAG === /* LearnMore */0) {
      return React.createElement(LearnMoreModal.make, {
                  modal_state: modal_state,
                  title: modal_state._0,
                  content: modal_state._1,
                  close_modal: (function (param) {
                      return Curry._1(toggle_modal, (function (param) {
                                    
                                  }));
                    }),
                  isModalOpen: isModalOpen,
                  variant: variant
                });
    } else {
      return React.createElement(ScoreDetailsModal.make, {
                  modal_state: modal_state,
                  content: modal_state._0,
                  close_modal: (function (param) {
                      return Curry._1(toggle_modal, (function (param) {
                                    
                                  }));
                    }),
                  isModalOpen: isModalOpen
                });
    }
  } else {
    return null;
  }
}

function useModal(initialState, variant) {
  var match = React.useState(function () {
        return initialState;
      });
  var toggle_modal = match[1];
  var modalComponent = getModalComponent(match[0], toggle_modal, isModalOpen, variant);
  return [
          modalComponent,
          toggle_modal
        ];
}

export {
  isModalOpen ,
  getModalComponent ,
  useModal ,
  
}
/* react Not a pure module */
